<template>
  <el-dialog title="Retirar Placa do Imóvel" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="30%">
        <el-form size="small" label-position="top">
          <el-form-item label="Placas" style="width: 100%">
            <el-select v-model="placa.status" style="width: 100%">
                <el-option
                  v-for="item in ocorrenciaRetiradaPlaca"
                  :key="item.data"
                  :label="item.label"
                  :value="item.data">
                </el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="Data de Colocação">
            <el-input v-model="placa.dataRemocao" v-mask="'##/##/####'"/>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="retirarPlaca" type="primary" size="small">Confirmar</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { OCORRENCIA_RETIRADA_PLACA } from '../../util/constantes.js';

export default {
  props: {
    placa: Object,
    visibility: Boolean
  },
  computed: {
    ocorrenciaRetiradaPlaca() { return OCORRENCIA_RETIRADA_PLACA }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('imoveisStore', [
      'removerPlacaImovel'
    ]),
    retirarPlaca() {
      let payload = this.placa;

      this.showLoading()
      this.removerPlacaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>
